module.exports = __webpack_public_path__ + "img/alpha.1e109221.svg";